import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { Loading } from '@common/components/loading';

import { TextEdit } from '../../../text-edit';
import { TextField } from '../../../text-field';
import { BackBtn } from '../../../back-btn';
import { Subtitle } from '../../../subtitle';

import { useTwinPageController } from './twin-page.controller';
import { TwinPageProps } from './twin-page.types';

import './twin-page.styles.scss';

export const TwinPage: React.FC<TwinPageProps> = (props) => {
  const { cachedData, onGoBack, errors } = props;

  const {
    loadingPage,
    handlePageNameChange,
    handlePageDescriptionChange,
  } = useTwinPageController(props);
  
  if (loadingPage || !cachedData) {
    return (
      <div className="FhqDesignToolQuestionnaireDesignerPage">
        <Loading size={20} margin="20px" />
      </div>
    );
  }

  return (
    <div className="FhqDesignToolQuestionnaireDesignerTwinPage">
      <BackBtn className="FhqDesignToolQuestionnaireDesignerTwinPage__back-btn" onClick={onGoBack} />
      <TextEdit 
        errors={errors?.properties?.title}
        required
        metadata={{
          description: 'page-name',
        }}
        value={cachedData.title}
        onChange={handlePageNameChange}
      />
      <Subtitle type="chip" text={I18n.t('Twin')} />
      <TextField 
        metadata={{
          description: 'page-description',
        }}
        type="textarea"
        classes={{
          label: 'FhqDesignToolQuestionnaireDesignerTwinPage__description-label',
          labelInputWrapper: 'FhqDesignToolQuestionnaireDesignerTwinPage__description-input-label-wrapper',
          input: 'FhqDesignToolQuestionnaireDesignerCousinPage__description-input'
        }}
        label={I18n.t('Page Description')}
        value={cachedData.description ?? ''}
        onChange={handlePageDescriptionChange}
      />
    </div>
  );
};